import extend from 'extend'

const libs = {
  // CKEDITOR
  ckeditor: null
}

// 允许覆盖默认配置
export const merge = (opts = {}) => {
  extend(true, libs, opts)
}

export default libs



// WEBPACK FOOTER //
// ./src/packages/libs/index.js